export enum SyncStatus {
    saving = "Saving",
    saved = "Saved",
    failed = "Failed"
}